import React, { Component } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './talk-card.css';

export default class TalkCard extends Component {
  constructor(props) {
    super(props);

    this.openHome = this.openHome.bind(this);
  }

  componentWillMount() {
    AOS.init();
  }
  
  openHome() {
    window.location = window.location.origin + window.location.pathname + "#/";
  }

  render() {
    return (
      <div className="rdp-react-template-component-talk-card" style={{backgroundImage: `url(${this.props.cover})`}}>
        <div className="rdp-react-template-component-talk-card-overlay">
          <div className="rdp-react-template-component-talk-card-host">
            <span className="rdp-react-template-component-talk-card-avatar" style={{backgroundImage: `url(${this.props.profile})`}} data-aos="fade-up" data-aos-duration="1000"></span>
            <span className="rdp-react-template-component-talk-card-host" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">{this.props.host}</span>
          </div>
          <span className="rdp-react-template-component-talk-card-title" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="400">{this.props.title}</span>
          <div className="rdp-react-template-component-talk-card-info" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="600">
            <span className="rdp-react-template-component-talk-card-info-item clock">{this.props.date}</span>
            <span className="rdp-react-template-component-talk-card-info-item persons">57</span>
            {/* <span className="rdp-react-template-component-talk-card-info-item share">14</span> */}
          </div>
        </div>
      </div>
    );
  }
}
